import React from "react"
import { CardWrapper, TextAndContent } from "./styles"

export const Card = ({ title, description, delay, padding, children }) => {
  return (
    <CardWrapper
      data-sal="slide-up"
      data-sal-delay={delay}
      data-sal-easing="ease"
      padding={padding}
    >
      {children}
      {title && (
        <TextAndContent>
          <h1>{title}</h1>
          <p>{description}</p>
        </TextAndContent>
      )}
    </CardWrapper>
  )
}
